import { db } from '@/firebase'

export default {
  saveNotificacion({ rootState, rootGetters }, not) {
    const negocio = rootState.app.negocioGest;
    const id = not.id;
    delete not.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio).collection('notificaciones')
        .doc(id).set(not, { merge: true }).then(() => {
          return id;
        })
    } else {
      not.createdBy = rootGetters['auth/role']
      not.activo = true;
      not.eliminado = false;
      not.repeticionLanzada = 0;
      p = db.collection('negocios').doc(negocio).collection('notificaciones')
        .add(not).then((r) => { return r.id })
    }
    return p;
  },
  deleteNotificacion({ rootState }, not) {
    const negocio = rootState.app.negocioGest;
    const id = not.id;
    return db.collection('negocios').doc(negocio).collection('notificaciones')
      .doc(id).delete()
  },
  getNotificaciones({ rootState, commit }) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('notificaciones')
      .get()
      .then((snap) => {
        var res = [];
        snap.forEach(e => {
          res.push({
            ...e.data(),
            id: e.id
          })
        });
        commit('setNotificaciones', res);
      })

  },
  getNotificacion({ rootState, commit }, id) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('notificaciones')
      .doc(id).get()
      .then((n) => {
        if (!n.exists) return Promise.reject("Notificación no existe");
        return {
          ...n.data(),
          id: n.id
        }
      })

  },
  changeActivo({ rootState }, payload) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('notificaciones')
      .doc(payload.id).get()
      .then((not) => {
        var res = [];
        if (not.exists) {
          var ref = not.ref;
          return ref.set({ activo: payload.activo }, { merge: true })
        } else {
          return Promise.reject("Notificación no encontrada")
        }
      })
  }
}